import { useLocation } from 'react-router-dom';

function useQueryParameter(name: string): string | null {
  return new URLSearchParams(useLocation().search).get(name);
}

export default useQueryParameter;
